module.exports = require('./helpers/bundle-url').getBundleURL('4AlMw') + "logo_trademark.d44631eb.png" + "?" + Date.now();